import { createContext, useState } from 'react';

const METRICS_TABS = {
  ordersIncome: 0,
  ordersCount: 1,
  orderBags: 2,
  deliveryBags: 3,
};

export const MetricsTabsContext = createContext({});

const MetricsTabsContextProvider = ({ children }) => {
  const [metricsActiveIndex, setMetricsActiveIndex] = useState(
    METRICS_TABS.ordersIncome
  );

  return (
    <MetricsTabsContext.Provider
      value={{
        metricsActiveIndex,
        setMetricsActiveIndex,
      }}
    >
      {children}
    </MetricsTabsContext.Provider>
  );
};

export default MetricsTabsContextProvider;
